import React from "react";
import getStyled from "../../hooks/getStyled";
import { SFEmptyListPlaceholderIcon } from "../icons";
import SFTypography from "../typography";
import { useTranslation } from "react-i18next";
import { SFStack } from "../grid";

const { styled } = getStyled();

const StyledWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(2),
  width: "100%",
  height: 400,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

const SFEmptyListPlaceholder = ({ message = null }) => {
  const { t } = useTranslation();

  return (
    <StyledWrapper>
      <SFStack spacing={2} alignItems="center">
        <SFEmptyListPlaceholderIcon size="screenPlaceholder" />
        <SFTypography variant="body1">
          {message || t("components.emptyPlaceholder.message")}
        </SFTypography>
      </SFStack>
    </StyledWrapper>
  );
};
export default SFEmptyListPlaceholder;
